import type { AxiosResponse } from 'axios'

/**
 * Le backend wrappe les réponses dans `{data: ...}` (ApiRenderer).
 * Pour les listes paginées DRF on peut recevoir soit `{data: {results: [...]}}`,
 * soit directement `{results: [...]}`, soit un tableau brut.
 */
export function unwrap<T>(resp: AxiosResponse<any>): T {
  const body = resp.data
  if (body && typeof body === 'object' && 'data' in body) return body.data as T
  return body as T
}

export function unwrapList<T>(resp: AxiosResponse<any>): T[] {
  const inner = unwrap<any>(resp)
  if (Array.isArray(inner)) return inner as T[]
  if (inner && Array.isArray(inner.results)) return inner.results as T[]
  return []
}

export interface PaginatedMeta {
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface PaginatedResult<T> {
  data: T[]
  meta: PaginatedMeta
}

/** Extrait `{data, meta}` quand le backend pagine avec ApiRenderer custom (Ubbfy). */
export function unwrapPaginated<T>(resp: AxiosResponse<any>): PaginatedResult<T> {
  const body = resp.data
  const data = Array.isArray(body?.data) ? body.data : []
  const meta = body?.meta || { current_page: 1, last_page: 1, per_page: data.length, total: data.length }
  return { data, meta }
}
